import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part9 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 5;
	chapterIds = {
		
		scenario4_5A_s16: 'CALM - Scenario 4 - 5A - Segment 16',
		scenario4_5A_s17: 'CALM - Scenario 4 End - 5A - Start - 1C - Segment 17',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part9.id;
	}

	public start() {
		const context = this;
		context.segment1Step1Miranda();
	}

	private segment1Step1Miranda() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario4_5A_s16, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C04-L3-000a',
			[{
				text: 'Have him call the hospital release of information desk when he gets home.',				
				feedback:'The Release of Information requires a signature. Mr. Zolic can complete the form and submit it while he’s still here. He’ll appreciate your support. ',
				scoreType: ScoreType.Worst2,
				isCorrect: false // Rank worst
			}, {
				text: 'Ask the Ward Clerk for a Release of Information form.',				
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}, {
				text: 'Tell him he can visit the Release of Information Office on his way out.',				
				feedback:'While this is a viable option, all of the information for his current hospitalization may not yet be in his file at this time.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank marginal/zero
			}, 
		],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1MirandaResponds(), context.partIndx);
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1MirandaResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5A_s17, () => {
			context.onDone();
		});
	}
}